import { h } from '../lib/dom.js';
import { apiDelete } from '../lib/api.js';
import { confirmModal, toast } from '../lib/ui.js';
import { fmtDate, visibilityLabel } from '../lib/format.js';

/**
 * Koç notu kartı — koç ve öğrenci panellerinde ortak.
 *
 * @param note            /api/coach-notes satırı
 * @param opts.canManage  Koç → Düzenle/Arşivle butonları; öğrenci → salt görüntüle
 * @param opts.showVisibility  Görünürlük chip'ini göster (koç panelinde faydalı)
 * @param opts.onEdit     Düzenleme handler (openNoteModal)
 * @param opts.refresh    Mutation sonrası listeyi yeniden çiz
 */
export function noteCard(note, opts = {}) {
  const { canManage = false, showVisibility = false, onEdit, refresh = () => {} } = opts;

  const meta = h('div', { class: 'note-meta row row-wrap' },
    h('span', {}, fmtDate(note.note_date)),
    showVisibility ? h('span', { class: 'chip' }, visibilityLabel(note.visibility)) : null,
    note.subject_name ? h('span', {}, '· ' + note.subject_name) : null,
    note.tag ? h('span', {}, '· #' + note.tag) : null,
    canManage ? h('span', { class: 'grow' }) : null,
    canManage && typeof onEdit === 'function' ? h('button', {
      class: 'btn btn-ghost btn-sm',
      onclick: () => onEdit(note),
    }, 'Düzenle') : null,
    canManage ? h('button', {
      class: 'btn btn-danger btn-sm',
      onclick: () => confirmModal({
        title: 'Notu arşivle', message: 'Bu not arşivlenecek.',
        confirmText: 'Arşivle', danger: true,
        onConfirm: async () => {
          await apiDelete('/coach-notes/' + note.id);
          toast('Arşivlendi');
          refresh();
        }
      }),
    }, '✕') : null,
  );

  return h('div', { class: 'note-card' },
    meta,
    note.title ? h('h4', { style: { marginBottom: 6 } }, note.title) : null,
    h('div', { class: 'note-content' }, note.content),
  );
}
